/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2022-08-12 15:40:46
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\warehouse\LIM.js
 */
/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-07-01 15:19:16
 */
/**
 * @Author fxg1997
 * @version 1.0
*/
export const queryPage = '/icps/system/sign/intelligent/warehouse/meter/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/warehouse/meter/saveOrUpdate'
import request from '@/utils/request'
/**获取特材名称列表*/
export function updateById(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/meter/uddateById',
    method: 'post',
    data
  })
}
/**获取特材名称列表*/
export function productList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryPage',
    method: 'post',
    data
  })
}
/**发送需求计划*/
export function saveneed(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/need/save',
    method: 'post',
    data
  })
}
/**库存盘点*/
export function stockTaking(data) {
  return request({
    url: '/icps/system/sign/intelligent/warehouse/meter/stockTaking',
    method: 'post',
    data
  })
}
/**盘点历史*/
export function recordsqueryPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/records/queryPage',
    method: 'post',
    data
  })
}
/**获取库存仓*/
export function getStoreHouse(data) {
  return request({
    url: '/icps/system/sign/basics/inventory/get_raw_details',
    method: 'post',
    data
  })
}
